import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Spin } from 'antd';


import { 
  Layout, 
  Menu, 
  theme, 
  Avatar, 
  Badge, 
  Dropdown, 
  Space, 
  Typography, 
  Button, 
  Grid,
  Card
} from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  BellOutlined,
  SettingOutlined,
  LogoutOutlined,
  DashboardOutlined,
  ProjectOutlined,
  TeamOutlined,
  MessageOutlined,
  HomeOutlined,
  RocketOutlined,
  PieChartOutlined,
  CloudOutlined,
  ShoppingCartOutlined ,
  BarChartOutlined ,
  FileOutlined,
  PlusCircleOutlined,
  ToolOutlined,
  ShopOutlined 
} from '@ant-design/icons';
 

import '../assets/css/modern-menu.css'; // Arquivo CSS adicional para estilos personalizados
import icon from '../assets/img/Lissot.ico'
import { useNavigate } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import Api from '../api/Api';

 

const { Header, Sider, Content } = Layout;
const { Text } = Typography;
const { useBreakpoint } = Grid;

const ModernMenu = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
     const navigate = useNavigate();
  const rootSubmenuKeys = ['2', '3', '4', '5', '6', '7', '8']; // só os menus de primeiro nível
const [selectedKey, setSelectedKey] = useState([]);
const location = useLocation();  
 const [nome, setNome] = useState('');
const [perfil, setPerfil] = useState('');
const [loadingLogout, setLoadingLogout] = useState(false);




useEffect(() => {
  const loginTime = parseInt(localStorage.getItem("loginTime"), 10) || Date.now();
  localStorage.setItem("loginTime", loginTime);

  const now = Date.now();
  const expired = now - loginTime > 3600000 ; // 1 hora

  if (expired) {
    logout();
    return;
  }

  const remainingTime = 3600000  - (now - loginTime); // 1h - tempo já passado
  const timeout = setTimeout(logout, remainingTime);

  return () => clearTimeout(timeout);
}, []);


const getMenuItemsByPerfil = () => {
  if (perfil === "ADMINISTRADOR") {
    return mainMenuItems;
  }

  if (perfil === "CAIXA/VENDAS") {
    return mainMenuItems
      .filter(item => ["2", "4"].includes(item.key)) // pega só Turno e Vendas
      .map(item => {
        if (item.key === "2") {
          // Remove Confirmar Turno
          return {
            ...item,
            children: item.children.filter(sub => sub.key !== "2-2"),
          };
        }
        return item;
      });
  }

  if (perfil === "FINANÇAS") {
    return mainMenuItems
      .filter(item => ["2", "3", "5"].includes(item.key)) // Turno, Tesouraria e Relatórios
      .map(item => {
        if (item.key === "2") {
          // Remove Confirmar Turno também para Finanças
          return {
            ...item,
            children: item.children.filter(sub => sub.key !== "2-2"),
          };
        }
        return item;
      });
  }

  return [];
};









useEffect(() => {
  let newOpenKeys = [];
  let newSelectedKey = [];

  const nome = JSON.parse(localStorage.getItem('nome'));
    setNome(nome);

  const perfil = JSON.parse(localStorage.getItem('perfil'));
  setPerfil(perfil);
 
  if (location.pathname.includes('/unidades')) {
    newOpenKeys = ['7'];
    newSelectedKey = ['7-9'];

  } 
  else if (location.pathname.includes('/produtos')) {
    newOpenKeys = ['7'];
    newSelectedKey = ['7-2'];

  } 
   else if (location.pathname.includes('/servicos')) {
    newOpenKeys = ['7'];
    newSelectedKey = ['7-3'];

  } 
  else if (location.pathname.includes('/familias')) {
    newOpenKeys = ['7'];
    newSelectedKey = ['7-6'];
  } else if (location.pathname.includes('/armazens')) {
    newOpenKeys = ['7'];
    newSelectedKey = ['7-5'];
  } else if (location.pathname.includes('/finalidades-pagamento')) {
    newOpenKeys = ['7', '7-4']; 
    newSelectedKey = ['7-4-5'];
  } else if (location.pathname.includes('/bancos')) {
    newOpenKeys = ['7', '7-4']; 
    newSelectedKey = ['7-4-1'];
  }
   else if (location.pathname.includes('/veiculos')) {
    newOpenKeys = ['7'];
    newSelectedKey = ['7-7'];
  }
else if (location.pathname.includes('/contas-bancarias')) {
    newOpenKeys = ['7', '7-4']; 
    newSelectedKey = ['7-4-2'];
  }

  else if (location.pathname.includes('/formas-pagamento')) {
    newOpenKeys = ['7', '7-4']; 
    newSelectedKey = ['7-4-3'];
  }

   else if (location.pathname.includes('/impostos')) {
    newOpenKeys = ['7', '7-4']; 
    newSelectedKey = ['7-4-4'];
  }
   else if (location.pathname.includes('/moedas')) {
    newOpenKeys = ['7', '7-4']; 
    newSelectedKey = ['7-4-7'];
  }
 
  else if (location.pathname.includes('/cambios')) {
    newOpenKeys = ['7', '7-4']; 
    newSelectedKey = ['7-4-6'];
  }
  else if (location.pathname.includes('/clientes')) {
    newOpenKeys = ['7', '7-1']; 
    newSelectedKey = ['7-1-1'];
  }
    else if (location.pathname.includes('/fornecedores')) {
    newOpenKeys = ['7', '7-1']; 
    newSelectedKey = ['7-1-2'];
  }

   else if (location.pathname.includes('/usuarios')) {
    newOpenKeys = ['7', '7-1']; 
    newSelectedKey = ['7-1-3'];
  }
    else if (location.pathname.includes('/entrada')) {
    newOpenKeys = ['6'];
    newSelectedKey = ['6-1'];
  } 

      else if (location.pathname.includes('/turno')) {
    newOpenKeys = ['2'];
    newSelectedKey = ['2-1'];
  } 
  
 else if (location.pathname.includes('/compra-fornecedor')) {
    newOpenKeys = ['6'];
    newSelectedKey = ['6-2'];
  } 
   else if (location.pathname.includes('/inventario')) {
    newOpenKeys = ['6'];
    newSelectedKey = ['6-3'];
  } 


 


  setOpenKeys(newOpenKeys);
  setSelectedKey(newSelectedKey);
}, [location.pathname]);





const logout = async () => {
  try {
    setLoadingLogout(true);
    const id = JSON.parse(localStorage.getItem('id'));
    const token = JSON.parse(localStorage.getItem('token'));

    const dados = { id: id };

    // Faz o logout na API (envia token no header)
    const response= await Api.Logout(dados);

    // Se quiser ver a resposta:
 //   console.log("Logout response:", response);

  } catch (error) {
    console.error("Erro ao fazer logout:", error);
  } finally {
    setLoadingLogout(false);
    // Limpa o localStorage e redireciona
    localStorage.removeItem("token");
    localStorage.removeItem("id");
    localStorage.removeItem("perfil");
    localStorage.removeItem("nome");
    window.location.href = "/";
  }
};




  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const screens = useBreakpoint();

const handleOpenChange = (keys) => {
  const latestKey = keys.find(k => !openKeys.includes(k));

  // Se estiver dentro de '7', só permite abrir um submenu de segundo nível por vez
  if (latestKey && latestKey.startsWith('7-')) {
    const isSecondLevel = latestKey.split('-').length === 2;

    if (isSecondLevel) {
      // Garante que '7' continue aberto, e somente um submenu de 2º nível dentro dele
      setOpenKeys(['7', latestKey]);
    } else {
      // Permite abrir subníveis internos como '7-4-3' (Forma de Pagamento)
      setOpenKeys(keys);
    }
  } else if (rootSubmenuKeys.includes(latestKey)) {
    
    setOpenKeys(latestKey ? [latestKey] : []);
  } else {
    setOpenKeys(keys);
  }
};



  const userMenuItems = [
     
   
     
    {
  key: '1',
  icon: <LogoutOutlined />,
  label: loadingLogout ? 'Terminando sessão...' : 'Terminar sessão',
  danger: true,
  disabled: loadingLogout,
  onClick: logout
}

  ];
const mainMenuItems = [
  {
    key: '1',
    icon: <DashboardOutlined />,
    label: 'Dashboard',
  },
  {
    key: '2',
    icon: <ProjectOutlined />,
    label: 'Turno',
    children: [
      { key: '2-1', label: 'Meu Turno',onClick: () => navigate('/turno') },
      { key: '2-2', label: 'Confirmar Turno' },
    ],
  },
  {
    key: '3',
    icon: <BarChartOutlined />,
    label: 'Tesouraria',
    children: [
      { key: '3-1', label: 'Saft' },
      { key: '3-2', label: 'Recibo' },
      { key: '3-3', label: 'Nota de pagamento' },
      { key: '3-4', label: 'Câmbio' },
      { key: '3-5', label: 'Conta corrente' },
      { key: '3-6', label: 'Conta por pagar' },
    ],
  },
  {
    key: '4',
    icon: <ShoppingCartOutlined />,
    label: 'Vendas',
    children: [
      { key: '4-1', label: 'Factura Recibo' },
      { key: '4-2', label: 'Factura' },
      { key: '4-3', label: 'Proforma' },
      { key: '4-4', label: 'Orçamento' },
      {
        key: '4-5',
        label: 'Guia',
        children: [
          { key: '4-5-1', label: 'Remessa' },
          { key: '4-5-2', label: 'Transporte' },
        ],
      },
    ],
  },
  {
    key: '5',
    icon: <FileOutlined />,
    label: 'Relatórios',
  },
  {
    key: '6',
    icon: <ShopOutlined />,
    label: 'Estoque',
      children:
      [
          {  key: '6-1', label: 'Entrada',onClick: () => navigate('/entrada')},
          {  key: '6-2', label: 'Compra a fornecedor',onClick: () => navigate('/compra-fornecedor')},
          {  key: '6-3', label: 'Inventário',onClick: () => navigate('/inventario')},
      ]
  },
  {
 
    key: '7',
    icon: <PlusCircleOutlined />,
    label: 'Cadastros',
     children: [
          { key: '7-1', label: 'Entidades',
            children: [
          { key: '7-1-1', label: 'Clientes',onClick: () => navigate('/clientes') },
          { key: '7-1-2', label: 'Fornecedores' ,onClick: () => navigate('/fornecedores')},
          { key: '7-1-3', label: 'Usuários' ,onClick: () => navigate('/usuarios')},
          
        ],

          },
          { key: '7-2', label: 'Produtos',onClick: () => navigate('/produtos') },
          { key: '7-3', label: 'Serviços' ,onClick: () => navigate('/servicos')},
          { key: '7-4', label: 'Finanças',
            children: [
          { key: '7-4-1', label: 'Bancos',onClick: () => navigate('/bancos')  },
          { key: '7-4-2', label: 'Contas Bancárias',onClick: () => navigate('/contas-bancarias') },
          { key: '7-4-3', label: 'Formas de Pagamento',onClick: () => navigate('/formas-pagamento')  },
          { key: '7-4-4', label: 'Taxas de Imposto',onClick: () => navigate('/impostos')  },
          { key: '7-4-5', label: 'Finalidades de Pagamento',onClick: () => navigate('/finalidades-pagamento') },
          { key: '7-4-6', label: 'Câmbios' ,onClick: () => navigate('/cambios')},
          { key: '7-4-7', label: 'Moedas',onClick: () => navigate('/moedas') },
         ],


          },
          { key: '7-5', label: 'Armazéns',onClick: () => navigate('/armazens') },
          { key: '7-6', label: 'Famílias',onClick: () => navigate('/familias') },
          { key: '7-7', label: 'Veículos',onClick: () => navigate('/veiculos') },
          { key: '7-9', label: 'Unidades' ,onClick: () => navigate('/unidades') },
        ],
  },
  {
    key: '8',
    icon: <ToolOutlined />,
    label: 'Operações',
  },

   {
      key: '9',
      icon: <SettingOutlined />,
      label: 'Configurações',
    },
];


if (loadingLogout) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Spin size="large" tip="Terminando sessão..." />
    </div>
  );
}

 
 return (
    <Layout className="modern-layout" style={{ minHeight: '100vh' }}>
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed}
        width={250}
        style={{
          background: 'linear-gradient(180deg, #184c9c 0%, #065aab 100%)',
          boxShadow: '0 0 20px rgba(0,0,0,0.1)',
          position: 'fixed',
          height: '100vh',
          zIndex: 100,
        }}
        className="modern-sider"
      >
        <div className="logo-container">
          {!collapsed ? (
            <div className="logo-expanded">
              <img src={icon} alt="Logo" style={{ width: 24, height: 24 }} />
              <Text strong style={{ color: '#fff', fontSize: 18, marginLeft: 10 }}>
                Lissoft
              </Text>
            </div>
          ) : (
            <div className="logo-collapsed">
              <img src={icon} alt="Logo" style={{ width: 24, height: 24 }} />
            </div>
          )}
        </div>

        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={selectedKey}
          defaultSelectedKeys={['1']}
          openKeys={openKeys}
          onOpenChange={handleOpenChange}
          style={{
            background: 'transparent',
            borderRight: 0,
            marginTop: 20,
          }}
          items={getMenuItemsByPerfil()} // aqui usa a função de filtro
        />
      </Sider>

      <Layout style={{ marginLeft: collapsed ? 80 : 250, transition: 'all 0.2s' }}>
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: '0 1px 4px rgba(0,21,41,.08)',
            position: 'sticky',
            top: 0,
            zIndex: 10,
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />

          <Space size="middle" style={{ marginRight: 24 }}>
            <Dropdown menu={{ items: userMenuItems }}>
              <div className="header-user">
                <Avatar size="default" icon={<UserOutlined />} />
                {screens.md && (
                  <Text strong style={{ marginLeft: 8 }}>
                    {nome}
                  </Text>
                )}
              </div>
            </Dropdown>
          </Space>
        </Header>

        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default ModernMenu;